export class LinesOfActionFailure {
    static INVALID_MOVE_LENGTH = () => $localize `Your move should have a length equal to the number of pieces that exist on the same line.`;
    static CANNOT_JUMP_OVER_OPPONENT = () => $localize `You cannot jump over the opponent's pieces.`;
    static PIECE_CANNOT_MOVE = () => $localize `This piece has no possible move, select another one.`;
}
